module.exports = __webpack_public_path__ + "img/tool3.fc512804.png";